import {
  PDC_SET_PAGINATION,
  PDC_SET_LIST,
  PDC_SET_SORT,
  PDC_SET_METRICS,
  PDC_SET_FILTERS,
  PDC_ADD_CURRENT_FILTERS,
  PDC_SET_KEY_FILTER_SELECTED,
  PDC_SET_CURRENT_FILTERS,
  PDC_SET_RANGES
} from "../types";

import { createReducer } from "./functions";

const initialState = {
  pdcsList: [],
  page: 0,
  pages: 0,
  pageSize: 10,
  hasNext: true,
  sort: { pdc_id: 1 },
  metrics: {},
  filters: null,
  currentFilters: {},
  keyFilterSelected: null,
  ranges: []
};

const setFilters = {
  [PDC_SET_FILTERS]: (state, action) => {
    let newFilters = { ...state.filters };
    newFilters[action.key] = action.values;
    return { ...state, filters: newFilters };
  }
};

const addCurrentFilter = {
  [PDC_ADD_CURRENT_FILTERS]: (state, action) => {
    const currentFilters = state.currentFilters || {};
    currentFilters[action.key] = action.filters;
    return Object.assign({}, state, { currentFilters: currentFilters });
  }
};
const setKeyFilterSelected = {
  [PDC_SET_KEY_FILTER_SELECTED]: (state, action) => {
    return { ...state, keyFilterSelected: action.key };
  }
};

const setCurrentFilters = {
  [PDC_SET_CURRENT_FILTERS]: (state, action) => {
    const currentFilters = { ...action.currentFilters };
    return Object.assign({}, state, {
      currentFilters: currentFilters
    });
  }
};

const setPagination = {
  [PDC_SET_PAGINATION]: (state, action) => {
    return { ...state, page: action.page, pages: action.pages };
  }
};
const setPdcsList = {
  [PDC_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages) {
      hasNext = false;
    }

    return {
      ...state,
      pdcsList: action.payload.docs,
      page,
      pages,
      hasNext
    };
  }
};

const setSort = {
  [PDC_SET_SORT]: (state, action) => {
    if (!action.data || !action.data.column) return state;
    return {
      ...state,
      sort: { [action.data.column]: action.data.sortOrder }
    };
  }
};

const setMetrics = {
  [PDC_SET_METRICS]: (state, action) => {
    return { ...state, metrics: action.payload };
  }
};

const setRanges = {
  [PDC_SET_RANGES]: (state, action) => {
    return { ...state, ranges: action.payload };
  }
};
const pdcsReducer = createReducer(initialState, {
  ...setPagination,
  ...setPdcsList,
  ...setSort,
  ...setMetrics,
  ...setFilters,
  ...addCurrentFilter,
  ...setKeyFilterSelected,
  ...setCurrentFilters,
  ...setRanges
});

export default pdcsReducer;



// WEBPACK FOOTER //
// src/redux/reducers/pdcsReducer.js